export enum OwnerRole {
  Developer,
  Admin,
  Full,
}
